import { useRef } from "react";

const allowedOtt = [
  "netflix","appletv","altt","jiocinema",
  "jiohotstar","voot","vrotttv",
  "disneyplus","distrotv","hoichoi",
  "mxplayer","ottplay","playfix"
];

export default function OttRow({ title, data, onClick, viewAll, onViewAll }) {

  const rowRef = useRef();

  const filtered = data.filter(app =>
    allowedOtt.includes(app.id.toLowerCase())
  );

  /* REMOTE KEY CONTROL */
  const handleKey = (e, index) => {
    const cards = document.querySelectorAll(".ott-card");

    if (e.key === "ArrowRight") {
      cards[index + 1]?.focus();
    }

    if (e.key === "ArrowLeft") {
      cards[index - 1]?.focus();
    }

    if (e.key === "Enter") {
      cards[index]?.click();
    }
  };

  return (
    <>
      <div className="ott-wrap">

        {/* HEADER */}
        <div className="ott-head">
          <h3 className="ott-title">{title}</h3>

          {viewAll && (
            <span 
              className="viewAll"
              onClick={onViewAll}
              tabIndex="0"
            >
              View All
            </span>
          )}
        </div>

        <div className="ott-container">

          {/* LEFT */}
          <div
            className="ott-arrow"
            onClick={() => rowRef.current.scrollLeft -= 300}
          >
            ❮
          </div>

          {/* ROW */}
          <div className="ott-row" ref={rowRef}>
            {filtered.map((item, index) => (
              <div
                key={item.id}
                className="ott-card"
                tabIndex="0"
                onKeyDown={(e)=>handleKey(e,index)}
                onClick={() => onClick(item)}
              >
                <img src={item.logo} alt={item.name} />
              </div>
            ))}
          </div>

          {/* RIGHT */}
          <div
            className="ott-arrow"
            onClick={() => rowRef.current.scrollLeft += 300}
          >
            ❯
          </div>

        </div>
      </div>

{/* ================= STYLE ================= */}
<style>{`

/* WRAP */
.ott-wrap{
  padding:20px 30px;
}

/* HEADER */
.ott-head{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:14px;
}

.ott-title{
  font-size:22px;
  font-weight:700;
}

.viewAll{
  font-size:14px;
  color:#aaa;
  cursor:pointer;
}
.viewAll:hover{
  color:#fff;
  text-decoration:underline;
}

/* CONTAINER */
.ott-container{
  display:flex;
  align-items:center;
}

/* ARROWS */
.ott-arrow{
  font-size:32px;
  color:#777;
  padding:0 12px;
  cursor:pointer;
}
.ott-arrow:hover{
  color:#fff;
}

/* ROW */
.ott-row{
  display:flex;
  gap:28px;
  padding:16px;
  overflow-x:auto;
  flex:1;
  scroll-behavior:smooth;
}
.ott-row::-webkit-scrollbar{
  display:none;
}

/* CARD */
.ott-card{
  width:160px;
  height:160px;
  border-radius:50%;
  background:transparent;   /* NO BACKGROUND */
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  outline:none;
  transition:.3s ease;
}

/* LOGO */
.ott-card img{
  width:115px;
  height:115px;
  object-fit:contain;
  border-radius:24px;
  padding:6px;
  transition:.3s;
}

/* HOVER GLOW */
.ott-card:hover img{
  transform:scale(1.1);
  box-shadow:
    0 0 25px #e50914,
    0 0 60px rgba(229,9,20,.7);
}

/* TV REMOTE FOCUS */
.ott-card:focus img{
  transform:scale(1.15);
  box-shadow:
    0 0 25px #e50914,
    0 0 60px rgba(229,9,20,.8);
}

/* ARROW KEY FEEL */
.ott-card:active img{
  transform:scale(1.05);
}

`}</style>

    </>
  );
}
